module.exports = __webpack_public_path__ + "assets/e4a7ddbc52c914221534a8517731f281.png";